/**
 * Page Notre Mission - FTPE Outremer
 */
import React from 'react';
import { Target, Users, Shield, Briefcase, Globe, Award, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';
import BackButton from '../components/BackButton';

// Logo FTPE Outremer
const FTPE_LOGO = "https://customer-assets.emergentagent.com/job_80d9c916-7281-4428-9c84-a6e0cd256c92/artifacts/ojac2aim_logo%20ftpe%20outremer%20dans%20fond%20blanc.png";

export default function FTPEMissionPage() {
  const navigate = useNavigate();

  const missions = [
    {
      icon: Users,
      title: "Représentation patronale",
      description: "Défendre les intérêts collectifs des TPE ultramarines auprès des pouvoirs publics et des partenaires sociaux."
    },
    {
      icon: Shield,
      title: "Sécurisation de l'activité",
      description: "Faciliter l'accès à des dispositifs de prévention et de gestion des risques adaptés aux réalités ultramarines."
    },
    {
      icon: Target,
      title: "Accompagnement territorial",
      description: "Promouvoir le développement économique local et l'ancrage territorial des entreprises."
    },
    {
      icon: Briefcase,
      title: "Formation & information",
      description: "Informer les adhérents sur leurs droits, obligations et opportunités dans un environnement réglementaire complexe."
    }
  ];

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-slate-900 via-green-900 to-slate-900 text-white py-20 px-6">
        <div className="max-w-5xl mx-auto">
          <div className="mb-6">
            <BackButton variant="dark" label="Retour" />
          </div>
          
          <div className="flex items-center gap-6 mb-8">
            <img src={FTPE_LOGO} alt="FTPE Outremer" className="w-20 h-20 object-contain rounded-lg bg-white p-2" />
            <div>
              <h1 className="text-4xl md:text-5xl font-bold mb-2">
                Nos <span className="text-amber-400">missions</span>
              </h1>
              <p className="text-xl text-slate-300">FTPE Outremer – Syndicat patronal des TPE ultramarines</p>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <div className="max-w-5xl mx-auto bg-white shadow-lg -mt-10 relative z-10 rounded-2xl p-8 md:p-12 mb-12">
        
        {/* Section Raison d'être */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-green-700 mb-4 flex items-center gap-3">
            <Globe className="w-6 h-6" />
            Raison d'être
          </h2>
          <p className="text-lg text-slate-700 leading-relaxed">
            La FTPE Outremer porte la voix des Très Petites Entreprises et employeurs
            ultramarins. Elle agit pour leur reconnaissance, leur développement durable
            et la valorisation de leur rôle économique et social sur les territoires.
          </p>
        </section>

        {/* Section Nos missions */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-green-700 mb-6 flex items-center gap-3">
            <Award className="w-6 h-6" />
            Nos missions principales
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            {missions.map((mission, index) => (
              <div key={index} className="bg-slate-50 p-6 rounded-xl border-l-4 border-amber-500 hover:shadow-md transition-all">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-green-100 rounded-lg">
                    <mission.icon className="w-6 h-6 text-green-700" />
                  </div>
                  <div>
                    <h3 className="font-bold text-slate-900 mb-2">{mission.title}</h3>
                    <p className="text-slate-600 text-sm leading-relaxed">{mission.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Section Engagement */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-green-700 mb-4">Notre engagement</h2>
          <div className="bg-gradient-to-r from-green-50 to-amber-50 p-6 rounded-xl border border-green-200">
            <p className="text-slate-700 leading-relaxed">
              La FTPE Outremer s'engage à agir dans l'intérêt exclusif de ses adhérents,
              en toute indépendance, transparence et responsabilité.
              Elle ne poursuit aucun but lucratif et veille à la séparation stricte
              entre son rôle syndical et les activités de ses partenaires.
            </p>
          </div>
        </section>

        {/* CTA */}
        <div className="text-center">
          <Button 
            onClick={() => navigate('/adhesion-ftpe-workflow')}
            className="bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white px-8 py-4 text-lg rounded-xl"
          >
            Adhérer à la FTPE Outremer
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
          <p className="text-sm text-slate-500 mt-3">Cotisation annuelle : 200 €</p>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-8 text-center">
        <p className="font-semibold">FTPE Outremer – Syndicat patronal ultramarin</p>
        <p className="text-slate-400 text-sm mt-2">Représentation • Accompagnement • Développement territorial</p>
      </footer>
    </div>
  );
}
